module.exports = __webpack_public_path__ + "img/8-min.a2e11891.jpg";